(function ($) {
  $(document).ready(function () {
    collection.init();
  });

  if ($(".engoj-collection-sidebar")) {
    History.Adapter.bind(window, "statechange", function () {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }

  var collection = {
    init: function () {
      /* Collection Filter */
      this.initCollectionFilter();
      /* Collection Show */
      this.initCollectionShow();

      /* Collection Sorting */
      this.initCollectionSorting();
    },

    /* --------------------------------------------------------- */
    /* Review */
    initReview: function () {
      // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
    },

    /* Hide Dropdown */
    initToggle: function () {},

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function () {},

    fillterTagEvents: function () {
      $("body").delegate(
        '.filter-tag a:not(".clear"), .filter-tag label',
        "click",
        function (e) {
          $(this).toggleClass("active");
          var selected = $(this).text();
          var text1 = "";
          $(this).closest(".dropdown").find(".dropdown-label").text(selected);
          if (!$(this).hasClass("open")) {
            // This element does not have the .do-not-want class
            $(this).closest(".dropdown").find(".dropdown-label").text(text1);
          }
          var currentTags = [];

          if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split("+");
          }

          if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
            var otherTag = $(this).parents(".filter-tag").find("input:checked");
            if (otherTag.length > 0) {
              var tagName = otherTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  currentTags.splice(tagPos, 1);
                }
              }
            }
          }

          var tagName = $(this).prev().val();
          if (tagName) {
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
              currentTags.splice(tagPos, 1);
            } else {
              currentTags.push(tagName);
            }
          }
          if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join("+");
          } else {
            delete Shopify.queryParams.constraint;
          }
          collection.filterAjaxClick();
          e.preventDefault();
        }
      );
    },

    filterMapClearAll: function () {
      //clear all selection
      $("body").delegate("click", ".refined-widgets a.clear-all", function (e) {
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        collection.filterAjaxClick();
        e.preventDefault();
      });

      $("body").delegate(".filter-block .clear", "click", function (e) {
        var currentTags = [];
        var filterTag = $(this).parent().parent();
        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split("+");
        }
        filterTag.find("input:checked").each(function () {
          var selectedTag = $(this);
          var tagName = selectedTag.val();
          if (tagName) {
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
              //remove tag
              currentTags.splice(tagPos, 1);
            }
          }
        });
        filterTag.find("a").each(function () {
          $(this).removeClass("active");
        });
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join("+");
        } else {
          delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClear: function () {
      $(".filter-tag").each(function () {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          //has active tag
          filterTag.find(".clear").show();
        }
      });
    },

    filterParams: function () {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (
          var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
          i < aCouples.length;
          i++
        ) {
          aKeyValue = aCouples[i].split("=");
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
              decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    filterMapEvents: function () {
      collection.fillterTagEvents();
    },

    resetFilter: function () {
      $(".filter-custom .active, .filter-links .active").removeClass("active");
      $(".filter-tag input:checked").attr("checked", false);

      //category
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".filter-links a[href='" + cat[0] + "']").addClass("active");
      }
    },

    filterMapData: function (data) {
      var currentList = $(".product-collection-grid");

      var productList = $(data).find(".product-collection-grid");

      currentList.replaceWith(productList);

      //replace paging
      if ($(".pagination").length > 0) {
        $(".pagination").replaceWith($(data).find(".pagination"));
      }

      $(".filter-blocks").replaceWith($(data).find(".filter-blocks"));
      collection.filterMapClear();
    },

    filterCreateUrl: function (baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, "+");
      if (baseLink) {
        if (newQuery != "") return baseLink + "?" + newQuery;
        else return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    filterAjaxClick: function (baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState(
        {
          param: Shopify.queryParams,
        },
        newurl,
        newurl
      );
      collection.filterGetContent(newurl);
    },

    filterGetContent: function (newurl) {
      $.ajax({
        type: "get",
        url: newurl,
        beforeSend: function () {
          showPopup(".loading");
        },

        success: function (data) {
          collection.filterMapData(data);

          collection.filterMapClear();
          hidePopup(".loading");
        },

        error: function (xhr, text) {
          hidePopup(".loading");
          $(".ajax-error-message").text(
            $.parseJSON(xhr.responseText).description
          );
          showPopup(".ajax-error-modal");
        },
      });
    },

    initCollectionFilter: function () {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();
      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function () {
      $(".wrap-filter-sorting li a").on("click", function (e) {
        e.preventDefault();

        if (!$(this).parent().hasClass("active")) {
          // Ensure object exists
          Shopify.queryParams = Shopify.queryParams || {};

          // 1) Prefer an explicit data attribute
          var sortVal = $(this).data("sort");

          // 2) Fallback: if href is like "?sort_by=price-ascending", parse that
          if (!sortVal) {
            var href = $(this).attr("href") || "";
            var qs = href.indexOf("?") > -1 ? href.split("?")[1] : "";
            if (qs) {
              var params = new URLSearchParams(qs);
              sortVal = params.get("sort_by");
            }
          }

          // If we still didn't get a value, bail to avoid creating bad URLs
          if (!sortVal) return;

          Shopify.queryParams.sort_by = sortVal;

          // Your existing AJAX refresh (or navigation) logic
          collection.filterAjaxClick();

          $(".wrap-filter-sorting li a.active").removeClass("active");
          $(this).addClass("active");
        }

        // Update label / close dropdown (unchanged)
        var selected = $(this).text();
        $(this).closest(".filter").find(".dropdown-label").text(selected);
        $(this).closest(".dropdown-toggle").removeClass("active");
      });
    },

    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function () {},

    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function () {
      $(".filter-show a").click(function (e) {
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          var currentPage = $(this).attr("href");
          var view = $(".button-view a.active").attr("data-mode");
          if (view == "list") {
            Shopify.queryParams.view = "list" + currentPage;
          } else {
            Shopify.queryParams.view = currentPage;
          }
          collection.filterAjaxClick();
          $(".filter-show li.active").removeClass("active");
          $(this).parent().addClass("active");
          $(this)
            .closest(".dropdown")
            .find(".dropdown-label")
            .text(currentPage);
          $(this).closest(".dropdown-content").removeClass("active");
        }
      });
    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function () {},
  };
})(jQuery);
